/* Movatic WMS — Mobile Ship | CesarFilho 932048016 */
export default function Ship() {
    return (
        <div className="py-3 grid gap-3">
            <div className="card p-3">
                <div className="font-semibold">Expedição</div>
                <div className="text-sm text-neutral-500 mt-1">
                    Selecione o pedido, separe (picking), confira e finalize. (Wizard aqui)
                </div>
            </div>
        </div>
    )
}
